// Thanks http://stackoverflow.com/questions/1638337/the-best-way-to-synchronize-client-side-javascript-clock-with-server-date
import 'whatwg-fetch';

const getTime = () => (new Date()).getTime();

const getServerTime = (url) => {
    const clientTimestamp = getTime();
    return fetch(`${url}?time=${clientTimestamp}`, {
        method: 'GET',
    })
    .then(response => response.text())
    .then((response) => {
        const nowTimeStamp = getTime();
        const responseParts = response.split(',');
        const serverTimestamp = parseInt(responseParts[0], 10);
        const serverClientRequestDiffTime = parseInt(responseParts[1], 10);
        const serverClientResponseDiffTime = nowTimeStamp - serverTimestamp;
        const responseTime = (
            (serverClientRequestDiffTime - nowTimeStamp) +
            (clientTimestamp - serverClientResponseDiffTime)
        ) / 2;
        return nowTimeStamp + responseTime;
    });
};

export default getServerTime;



// WEBPACK FOOTER //
// ./lib/getServerTime.js